<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-simple-table dense class="elevation-1">
          <thead>
            <tr>
              <th>Path</th>
              <th>View</th>
              <th>Origem</th>
              <th>Status</th>
              <th>Permissões Paths</th>
              <th>Permissões Menu</th>
              <th>Arquivo Vue</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="verificacaoRotas.length === 0">
              <td colspan="7" class="bg-blue-100 text-blue-800 text-center font-semibold">
                Nenhum problema encontrado 🎉
              </td>
            </tr>
            <tr v-for="item in verificacaoRotas" :key="item.path" :class="{ 'bg-red-100': item.status !== 'OK', 'bg-green-100': item.status === 'OK' }">
              <td>    <a :href="item.path" target="_blank" class="text-blue-600 underline">{{ item.path }}</a></td>
              <td>{{ item.view || '-' }}</td>
              <td>{{ item.origem }}</td>
              <td><strong>{{ item.status }}</strong></td>
              <td colspan="2" v-if="item.pathPerms.length === 0 && item.menuPerms.length === 0">Público</td>
              <td colspan="2" v-else-if="JSON.stringify(item.pathPerms) === JSON.stringify(item.menuPerms)">
                Iguais: {{ item.pathPerms.join(', ') }}
              </td>
              <template v-else>
                <td colspan="2">
                  <span
                    v-for="perm in item.pathPerms"
                    :key="'p-' + perm"
                    :class="item.menuPerms.includes(perm) ? 'green' : 'yellow'"
                    class="mr-1"
                    :title="item.menuPerms.includes(perm) ? 'Ok' : 'Tem no path, mas falta no menu'"
                  >
                    {{ perm }}
                  </span>
                  <span
                    v-for="perm in item.menuPerms"
                    :key="'m-' + perm"
                    v-if="!item.pathPerms.includes(perm)"
                    title="Tem no menu, mas falta no path"
                    class="red mr-1"
                  >
                    {{ perm }}
                  </span>
                 
                </td>
              </template>
              <td>{{ item.vueFile ? '✅' : '❌' }}</td>
            </tr>
          </tbody>
        </v-simple-table>
        <h2>1. Paths existentes que não estão no menu.js</h2>
        <v-simple-table dense>
          <thead>
            <tr><th>Path</th><th>View</th></tr>
          </thead>
          <tbody>
            <tr v-for="item in onlyInPaths" :key="item.path">
              <td>{{ item.path }} <a :href="item.path" target="_blank">+</a></td>
              <td>{{ item.view }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>

      <v-col cols="12">
        <h2>2. Menu.js com rotas que não estão em paths.js</h2>
        <v-simple-table dense>
          <thead>
            <tr><th>To</th><th>Text</th></tr>
          </thead>
          <tbody>
            <tr v-if="onlyInMenu.length === 0">
              <td colspan="3" class="bg-blue-100 text-blue-800 text-center font-semibold">
                Nenhum dado bugado 🎉 
              </td>
            </tr>
            <tr v-for="item in onlyInMenu" :key="item.to">
              <td>{{ item.to }}</td>
              <td>{{ item.text }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>

      <v-col cols="12">
        <h2>3. Rotas com permissões diferentes entre paths.js e menu.js</h2>
        <v-simple-table dense>
          <thead>
            <tr><th>Path</th><th>Permissões paths.js</th><th>Permissões menu.js</th></tr>
          </thead>
          <tbody>
            <tr v-if="permissionConflicts.length === 0">
              <td colspan="3" class="bg-blue-100 text-blue-800 text-center font-semibold">
                Nenhum dado bugado 🎉 
              </td>
            </tr>
            <tr v-for="item in permissionConflicts" :key="item.path">
              <td>{{ item.path }}</td>
              <td>{{ item.pathPerms.join(', ') }}</td>
              <td>{{ item.menuPerms.join(', ') }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>

      <v-col cols="12">
        <h2>4. Paths sem componente .vue correspondente</h2>
        <v-simple-table dense>
          <thead>
            <tr><th>Path</th><th>View</th></tr>
          </thead>
          <tbody>
            <tr v-for="item in missingVueFiles" :key="item.path">
              <td>{{ item.path }}</td>
              <td>{{ item.view }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>

      <v-col cols="12">
        <h2>5. OK - Está em paths, menu e tem .vue</h2>
        <v-simple-table dense>
          <thead>
            <tr><th>Path</th><th>View</th><th>Permissões</th></tr>
          </thead>
          <tbody>
            <tr v-for="item in fullyValidRoutes" :key="item.path">
              <td>{{ item.path }}</td>
              <td>{{ item.view }}</td>
              <td>{{ item.perms.join(', ') }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import menu from '../config/menu'
import paths from '../router/paths'
import perfis from '../config/perfis'

// Helper para normalizar permissões
const normalizePerms = perms =>
  (perms || []).map(p => typeof p === 'string' ? p : '').sort()
function extractMenuRoutes(menuItems) {
  const result = []

  menuItems.forEach(item => {
    const basePermission = item.permission || []

    if (item.to) {
      result.push({
        to: item.to,
        text: item.text,
        permission: basePermission
      })
    }

    if (item.subs && Array.isArray(item.subs)) {
      item.subs.forEach(sub => {
        if (sub.to) {
          result.push({
            to: sub.to,
            text: sub.text,
            permission: sub.permission || basePermission
          })
        }
      })
    }
  })

  return result
}
const statusPriority = status => {
  switch (status) {
    case 'OK': return 0
    case 'Permissões divergentes': return 1
    case 'Sem menu': return 2
    default: return 3
  }
}

export default {
  data() {
    return {
      verificacaoRotas: [],
      onlyInPaths: [],
      onlyInMenu: [],
      permissionConflicts: [],
      missingVueFiles: [],
      fullyValidRoutes: [],
    }
  },
  async mounted() {
    // Simula leitura dos arquivos .vue disponíveis na pasta views
    const vueFiles = await this.getVueComponents()

    // Mapas rápidos
    const flatMenu = extractMenuRoutes(menu)
    window.pathMap = Object.fromEntries(paths.map(p => [p.path?p.path:'/', p]))
    const pathMap = Object.fromEntries(paths.map(p => [p.path?p.path:'/', p]))
    const menuMap = Object.fromEntries(flatMenu.filter(p => p.to !== '/').map(p => [p.to, p]))

    //const pathMap = Object.fromEntries(paths.map(p => [p.path, p]))
    //const menuMap = Object.fromEntries(menu.map(p => [p.to, p]))

    // 1. Só no paths.js
    this.onlyInPaths = paths.filter(p => !menuMap[p.path])

    // 2. Só no menu.js
    this.onlyInMenu = flatMenu.filter(m => !pathMap[m.to])

    // 3. Permissões diferentes
    this.permissionConflicts = paths
      .filter(p => menuMap[p.path])
      .filter(p => {
        const menuPerms = normalizePerms(menuMap[p.path].permission)
        const pathPerms = normalizePerms(p.permission)
        return JSON.stringify(menuPerms) !== JSON.stringify(pathPerms)
      })
      .map(p => ({
        path: p.path,
        pathPerms: normalizePerms(p.permission),
        menuPerms: normalizePerms(menuMap[p.path].permission)
      }))

    // 4. Paths sem .vue correspondente
    this.missingVueFiles = paths.filter(p => !vueFiles.includes(p.view + '.vue'))

    // 5. Está em tudo e com permissões ok
    this.fullyValidRoutes = paths
      .filter(p =>
        vueFiles.includes(p.view + '.vue') &&
        menuMap[p.path] &&
        JSON.stringify(normalizePerms(p.permission)) === JSON.stringify(normalizePerms(menuMap[p.path].permission))
      )
      .map(p => ({
        path: p.path,
        view: p.view,
        perms: normalizePerms(p.permission)
      }))
      this.verificacaoRotas = []

      //const vueFiles = this.getVueComponents()
      //const flatMenu = extractMenuRoutes(menu)
      //const pathMap = Object.fromEntries(paths.map(p => [p.path, p]))
      //const menuMap = Object.fromEntries(flatMenu.map(p => [p.to, p]))

      const normalize = p => (p || []).map(v => String(v)).sort()

      const allPaths = new Set([
        ...paths.map(p => p.path),
        ...flatMenu.map(m => m.to)
      ])
      debugger
      for (const path of allPaths) {
        const fromPath = pathMap[path]
        const fromMenu = menuMap[path]
        const view = (fromPath && fromPath.view) || '-'
        const vueFile = fromPath && fromPath.view && vueFiles.includes(fromPath.view + '.vue')
        const permsPath = normalize((fromPath && fromPath.permission) || [])
        const permsMenu = normalize(fromMenu && fromMenu.permission)

        let status = ''
        let origem = ''

        if (fromPath && fromMenu) {
          origem = 'ambos'
          if (JSON.stringify(permsPath) !== JSON.stringify(permsMenu)) {
            status = 'Permissões divergentes'
          } else if (!vueFile) {
            status = 'View ausente'
          } else {
            status = 'OK'
          }
        } else if (fromPath && !fromMenu) {
          origem = 'paths'
          status = !vueFile ? 'Sem menu e sem .vue' : 'Sem menu'
        } else if (!fromPath && fromMenu) {
          origem = 'menu'
          status = 'Sem path'
        }

        this.verificacaoRotas.push({
          path,
          view,
          origem,
          status,
          pathPerms: permsPath,
          menuPerms: permsMenu,
          vueFile
        })
      }
      this.verificacaoRotas.sort((a, b) => {
        return statusPriority(a.status) - statusPriority(b.status)
      })
      window.verificacaoRotas = this.verificacaoRotas

  },
  methods: {
    async getVueComponents() {
      // Busca todos os arquivos .vue em src/views
      const context = require.context('.', true, /\.vue$/)
      return context.keys().map(file => file.replace('./', ''))
    }

  }
}
</script>
